module.exports = __webpack_public_path__ + "static/media/omrade.beefa5e4.png";